import * as z from 'zod';

import { systemUserQuerySchema } from './system-user-query-schema';

export const systemUserUpdateSchema = systemUserQuerySchema
  .omit({ status: true, roles: true, profile_images: true, team_member: true, api_keys: true })
  .extend({
    status: z.string(),
    roles: z.array(z.number()),
    profile_images: z.array(z.number()),
  });

export type SystemUserUpdateSchema = z.infer<typeof systemUserUpdateSchema>;

export const systemUserCreateSchema = systemUserUpdateSchema.pick({
  first_name: true,
  last_name: true,
  status: true,
  email: true,
  team_member_id: true,
  // title: true,
  // birth_day: true,
  // birth_month: true,
  // linked_in_url: true,
  // twitter_handle: true,
  // clients: true,
});

export type SystemUserCreateSchema = z.infer<typeof systemUserCreateSchema>;
